module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAABCAYAAACv43fXAAAAAXNSR0IArs4c6QAAABlJREFUOBFj/A8EDKNgNARGQ2A0BEZgCAAA8SUD/kHeGdYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/progressBarChoose.png
// module id = /uN8
// module chunks = 1